import React from "react";
import { useTranslation } from "react-i18next";
import { HistoricalVelavuInvoice } from "velavu-js-api";
import VelavuSelect from "../../../elements/velavu-select";
import { mapInvoiceStatusText } from "../../../helper/language-helper";
import { formatBillingPeriod } from "./settings-billing-format";

export interface InvoiceSelectProps {
	invoices: HistoricalVelavuInvoice[];
	value: string;
	onChange: (invoiceID: string) => void;
}

export default function InvoiceSelect(props: InvoiceSelectProps) {
	const { t } = useTranslation();

	return (
		<VelavuSelect
			titleText={t("common.period")}
			value={props.value}
			onChange={props.onChange}
			fullWidth
		>
			{props.invoices.map((invoice) => (
				<option key={invoice.id} value={invoice.id}>
					{/* Option doesn't support HTML ;( */}
					{/*<span className={styles.indicator} style={{backgroundColor: mapInvoiceStatusColors(invoice.status)[0]}} />*/}
					{/*<span>{formatBillingPeriod(invoice.period_start, invoice.period_end)}</span>*/}

					{`${formatBillingPeriod(
						invoice.period_start,
						invoice.period_end,
					)} (${mapInvoiceStatusText(invoice.status, t)})`}
				</option>
			))}
		</VelavuSelect>
	);
}
